import Image from "@/components/Image";
import { GetEfficiencyStatsQuery } from "@/graphql/gql/graphql";
import styles from "./teamStats.module.scss";

export type BasicTeamT = NonNullable<
  GetEfficiencyStatsQuery["event"]
>["homeTeam"];

interface TeamStatsHeaderProps {
  homeTeam: BasicTeamT;
  awayTeam: BasicTeamT;
}
export default function TeamStatsHeader({
  homeTeam,
  awayTeam,
}: TeamStatsHeaderProps) {
  return (
    <div className={styles.header}>
      <div
        className={styles.team}
        style={{ backgroundColor: awayTeam?.primaryColor ?? undefined }}
      >
        <span>
          <Image
            width={29}
            height={26}
            alt={
              awayTeam?.abbreviation
                ? `${awayTeam.abbreviation} team logo`
                : "team logo"
            }
            src={awayTeam?.logoSVG}
          />
          {awayTeam?.abbreviation ?? null}
        </span>
      </div>
      <div
        className={styles.team}
        style={{ backgroundColor: homeTeam?.primaryColor ?? undefined }}
      >
        <span>
          <Image
            width={29}
            height={26}
            alt={
              homeTeam?.abbreviation
                ? `${homeTeam.abbreviation} team logo`
                : "team logo"
            }
            src={homeTeam?.logoSVG}
          />
          {homeTeam?.abbreviation ?? null}
        </span>
      </div>
    </div>
  );
}
